import { Heart } from "lucide-react";

function timeAgo(iso) {
  try {
    const then = new Date(iso).getTime();
    if (isNaN(then)) return "";
    const diff = Math.max(0, Date.now() - then);
    const m = Math.floor(diff / 60000);
    if (m < 1) return "just now";
    if (m < 60) return `${m}m ago`;
    const h = Math.floor(m / 60);
    if (h < 24) return `${h}h ago`;
    const d = Math.floor(h / 24);
    if (d < 7) return `${d}d ago`;
    const w = Math.floor(d / 7);
    return `${w}w ago`;
  } catch {
    return "";
  }
}

export default function DonorWall({ donors }) {
  const list = Array.isArray(donors) ? donors : [];

  return (
    <section
      id="donors"
      data-testid="donor-wall-section"
      className="relative scroll-mt-24 bg-[#0B0B0D] border-y border-[#27272A]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6">
          <div>
            <div className="text-[10px] uppercase tracking-[0.35em] text-[#FF007F]">
              The wall
            </div>
            <h2 className="font-display uppercase tracking-tight text-5xl md:text-6xl mt-3 leading-[0.9]">
              People who<br /> <span className="text-[#FF007F]">believe.</span>
            </h2>
          </div>
          <div className="text-sm text-[#A1A1AA] max-w-xs">
            Each name here is a brick in Camden's foundation. Yours could be next.
          </div>
        </div>

        {list.length === 0 ? (
          <div
            data-testid="donor-wall-empty"
            className="border border-dashed border-[#27272A] p-10 md:p-16 text-center"
          >
            <Heart className="h-10 w-10 mx-auto text-[#FF007F]" />
            <p className="font-display text-3xl uppercase mt-6">Be the first.</p>
            <p className="text-[#A1A1AA] mt-2">
              No supporters yet. Be the spark that starts the fire.
            </p>
            <a
              href="#donate"
              className="inline-flex items-center mt-8 bg-[#FF007F] text-white px-6 py-3 font-bold uppercase tracking-[0.2em]"
            >
              Give first
            </a>
          </div>
        ) : (
          <div data-testid="donor-wall-list" className="divide-y divide-[#27272A] border-y border-[#27272A]">
            {list.map((d, i) => (
              <div
                key={i}
                data-testid={`donor-row-${i}`}
                className="grid grid-cols-12 gap-4 py-6 items-start hover:bg-white/[0.015] transition-colors"
              >
                <div className="col-span-12 md:col-span-4">
                  <div className="text-white font-semibold text-lg">{d.donor_name}</div>
                  <div className="text-[10px] uppercase tracking-[0.25em] text-[#71717A] mt-1">
                    {timeAgo(d.created_at)}
                  </div>
                </div>
                <div className="col-span-12 md:col-span-6">
                  {d.message ? (
                    <p className="text-[#D4D4D8] italic font-light">"{d.message}"</p>
                  ) : (
                    <p className="text-[#52525B] text-sm">— sent quiet love —</p>
                  )}
                </div>
                <div className="col-span-12 md:col-span-2 md:text-right font-display text-2xl tabular text-[#00E5FF]">
                  ${Number(d.amount || 0).toFixed(0)}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
